module.exports = __webpack_public_path__ + "static/media/t-alphabet.838616a9.svg";